export default "__VITE_ASSET__4e2aef27__"